import TablerIcon from "../TablerIcon";

const CartFlyAnimation = ({ flights = [], onComplete }) => {
  if (!flights.length) return null;

  return (
    <div className="pos-cart-flight-layer" data-testid="cart-flight-layer" aria-hidden="true">
      {flights.map((flight) => (
        <div
          key={flight.id}
          className="pos-cart-flight"
          data-testid={`cart-flight-${flight.id}`}
          style={{
            "--pos-flight-size": `${flight.size}px`,
            "--pos-flight-start-x": `${flight.startX}px`,
            "--pos-flight-start-y": `${flight.startY}px`,
            "--pos-flight-mid-x": `${flight.midX}px`,
            "--pos-flight-mid-y": `${flight.midY}px`,
            "--pos-flight-end-x": `${flight.endX}px`,
            "--pos-flight-end-y": `${flight.endY}px`,
          }}
          onAnimationEnd={(event) => {
            if (event.target === event.currentTarget) {
              onComplete?.(flight.id);
            }
          }}>
          <div className="pos-cart-flight-preview">
            <TablerIcon name="package" size={24} className="pos-cart-flight-fallback" />
            {flight.imageUrl ? (
              <img
                src={flight.imageUrl}
                alt=""
                onError={(event) => {
                  event.currentTarget.style.display = "none";
                }}
              />
            ) : null}
            <span className="pos-cart-flight-count">+1</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CartFlyAnimation;
